import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LanguageService } from '@core/services/language.service';
import { LayoutService } from './app/layout/service/layout.service';
import { isPlatformBrowser } from '@angular/common';
import { updatePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  // Injecter le LanguageService pour qu'il s'initialise au démarrage
  private readonly languageService = inject(LanguageService);
  private readonly layoutService = inject(LayoutService);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    // Initialiser le thème avec la couleur primaire rose au démarrage
    if (isPlatformBrowser(this.platformId)) {
      this.initializeTheme();
    }
  }

  private initializeTheme(): void {
    const config = this.layoutService.layoutConfig();
    const primaryColorName = config.primary || 'rose';

    // Appliquer la couleur primaire depuis le preset Aura
    const colorPalette = Aura?.primitive?.[primaryColorName as keyof typeof Aura.primitive];

    if (colorPalette) {
      updatePreset({
        semantic: {
          primary: colorPalette,
        },
      });
    }
  }
}
